// #region Imports

import * as $ from 'jquery';
import * as PrintContent from './printContent';
import * as SidebarNotes from '../sidebarNotes';
import { INoteData } from '../../dto/INoteData';
import { noteTextToHtml } from '../helpers/noteTextFormatter';

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindPrintButton();
}

// #endregion Exports

// #region Private functions

function bindPrintButton(): void {
    $('.js-print-notes').on('click', printNotes);
}

function printNotes(event): void {
    event.preventDefault();

    const notes = SidebarNotes.getSelectedNotes();
    const content = notes.map((note) => { return formatNote(note) }).join('');
    
    PrintContent.print(content);
}

function formatNote(note: INoteData) {
    let title: string = '';
    let text: string = '';

    let work = $(`.notification[data-id="${note.id}"]`).closest('.notifications__notifications-item').find('a:first').clone();
    work.find('span').remove();
    const documentName = work.text(); 

    if (isNotNullOrEmpty(note.title)) {
        title = note.title;
    }

    if (isNotNullOrEmpty(note.text)) {
        text = noteTextToHtml(note.text);
    }
    else if (isNotNullOrEmpty(note.selection)) {
        try {
            text = `<i>Markering:</i> ${JSON.parse(note.selection).text}`;
        }
        finally {}
    }

    return `<div class="print-note"><div class="print-note__document">${documentName}</div>${title !== '' ? `<div class="print-note__title">${title}</div>` : ''}<div class="print-note__text">${text}</div></div>`;
}

function isNotNullOrEmpty(string: string) {
    return typeof(string) !== 'undefined' && string !== null && string !== '';
}

// #endregion Private functions